export const DESKTOP_CONTENT_MAX_WIDTH = 1440;